import React from "react";
import "./FormThankYou.css";
import IconButton from '@material-ui/core/IconButton';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import { RiQuestionnaireLine } from 'react-icons/ri';

function FormThankYou() {
  return (
    <div className="formRouteMainContainer">
      <div className="formThankYouMain">
        <div className="formThankYouContainer">
          <div className="formThankYouHeader">
            <div className="formThankYouHeaderContent"><h5>Thank You!</h5></div>
          </div>
          <div className="formThankYouContent">
            <p>
              Your form has been submitted successfully. <br /> <br />
              <h5> What's Next</h5>
              Please keep an eye on your inbox for further
              communication from one of our sales agents.  <br /> <br />

              {/* Feel free to get in touch with us. */}
              {/* In the meantime, you can check out our <a href="https://moveit.motorvia.co.za/Moveit/document?doc=costfactors" target="_blank">FAQ</a> that
              could affect your quote, or contact us on our
              social media platforms below. */}
            </p>
          </div>
          <div className="formThankYouFooter">
            <div className="footerHeader">Feel free to get in touch with us.</div>
            <div className="formThankYouFooterContent">

              <div className="faq">
                <a href="https://moveit.motorvia.co.za/Moveit/document?doc=costfactors" target="_blank">FAQ</a>

              </div>


              <IconButton href="https://www.facebook.com/MotorviaSA/" target="_blank">
                <FacebookIcon />
              </IconButton>
              <IconButton href="https://www.instagram.com/motorvia_sa/" target="_blank">
                <InstagramIcon />
              </IconButton>
            </div>
          </div>
          <div className="buttonSpacer"></div>
        </div>

        <div className="btn-container">
          <a href="https://moveit.motorvia.co.za/moveitquote" target="_blank"><button className="btn-next" >
            New quote
          </button></a>
          {/*
          <a href="/" target="_blank"><button className="btn-next" >
            Done
          </button>
          </a>*/}
        </div>
      </div>
    </div >

  );
}

export default FormThankYou;

/*
Thank  You
Your form has been submitted successfully.
Please keep an eye on your inbox for further
communication. One of our friendly Sales Agents
will be in touch with you shortly.
In the meantime, you can check out our
FAQ
 that
could affect your quote.
Or contact us on our
social media
platforms*/